/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscHolidayCalendar } from "../../funcs/miscGetMiscHolidayCalendar.js";
import { GetMiscHolidayCalendarRequest$zodSchema } from "../../models/getmischolidaycalendarop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscHolidayCalendarRequest$zodSchema.optional(),
};

export const tool$miscGetMiscHolidayCalendar: ToolDefinition<typeof args> = {
  name: "misc-get-misc-holiday-calendar",
  description: `查询节假日与万年历

查询指定日期、月份或年份的万年历与节假日信息。

## 功能概述
这个接口支持三种查询方式：按天（\`date\`）、按月（\`month\`）和按年（\`year\`）。调用时三者选一个传入即可。

如果你只关心某一类事件，可以通过 \`holiday_type\` 进行筛选，例如只看法定休假/调休、公历节日、农历节日或节气。

在 \`date\` 模式下，传 \`include_nearby=true\` 可以额外返回该日期前后最近的节日；返回数量由 \`nearby_limit\` 控制，默认 7，最大 30。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscHolidayCalendar(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
